export default "__VITE_ASSET__Dhm$8SY3__$_?nuxt_component=async&nuxt_component_name=IconFielmannDelivery&nuxt_component_export=default__"